<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 14,
                    wrapper: 10
                };
            }
        },
        data: {
            type: Object,
            default: ""
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {}
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e)

            this.form.validateFields((err, formData) => {
                if(!err) {
                    this.processing = true

                    let promise

                    promise = this.$http.put(
                        this.routeUri("api.classical-exam-attempt.update", {
                            attempt: this.data.id
                        }),
                        formData
                    );

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            })
        },

        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 1000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    }
}
</script>
<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout"  @submit="handleSubmit">
                    <a-form-item label="Score"
                    >
                        <a-input-number
                            :max="100"
                            :min="0"
                            v-decorator="[
                                'score',
                                {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Field ini wajib diisi'
                                        }
                                    ],
                                    initialValue: this.data.raw_score
                                }
                            ]"
                        >
                        </a-input-number>
                    </a-form-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>
